import React from "react";
import PropTypes from "prop-types";
import Region from "../../../../models/Region";

function OpenAnalysisLink({ region }) {
  if (!region) return null;

  return window.resultsConfig ? (
    <div
      data-tooltip="Open region in this analysis"
      data-tooltip-class="genome-browser-small-tooltip"
      className="tw-inline-block"
      onClick={() => {
        const detail = region.clinicalSearch;
        const ev = new CustomEvent("selectCall", { detail });
        document.dispatchEvent(ev);
      }}
    >
      <div className="hover:tw-text-blueGray-900 tw-flex tw-text-blueGray-700 tw-cursor-pointer tw-text-sm">
        <i className="fa fa-link" />
      </div>
    </div>
  ) : null;
}

OpenAnalysisLink.propTypes = {
  region: PropTypes.instanceOf(Region),
};

OpenAnalysisLink.defaultProps = {
  region: null,
};

OpenAnalysisLink.propTypes = {};

export default OpenAnalysisLink;
